module.exports = __webpack_public_path__ + "img/orange.10a52cab.svg";